// ============================================================
// FormField — Formik-connected Reusable Form Field
// ============================================================

import { TextField, Box } from '@mui/material';
import { useField } from 'formik';

export function FormField({
  name,
  label,
  type = 'text',
  placeholder,
  multiline = false,
  rows = 4,
  fullWidth = true,
  size = 'small',
  disabled = false,
  helperText,
  autoComplete = 'off',
  slotProps,
  ...props
}) {
  const [field, meta] = useField(name);
  const hasError = meta.touched && Boolean(meta.error);

  const effectiveAutoComplete = autoComplete === 'off' ? 'new-password' : (autoComplete || 'new-password');

  const mergedSlotProps = {
    ...slotProps,
    htmlInput: {
      autoComplete: effectiveAutoComplete,
      ...(slotProps?.htmlInput || {}),
    },
  };

  return (
    <Box sx={{ mb: 2 }}>
      <TextField
        {...field}
        {...props}
        autoComplete={effectiveAutoComplete}
        slotProps={mergedSlotProps}
        label={label}
        type={type}
        placeholder={placeholder}
        multiline={multiline}
        rows={multiline ? rows : undefined}
        fullWidth={fullWidth}
        size={size}
        disabled={disabled}
        error={hasError}
        helperText={hasError ? meta.error : helperText}
      />
    </Box>
  );
}
